// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__2uzqM","focusBorder":"styles_focusBorder__8F_7V","focusOffset":"styles_focusOffset__QZih3","hideFocus":"styles_hideFocus__YOqPj"};